var _title, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 45,
  height: 45,
  viewBox: "0 0 45 45",
  preserveAspectRatio: "xMidYMid meet"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "closeIcon")), /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "fullscreen"
}, /*#__PURE__*/React.createElement("g", {
  id: "fullscreen-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "circle"
}, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 22.5,
  r: 20.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M22.5,2A20.5,20.5,0,1,1,2,22.5,20.5,20.5,0,0,1,22.5,2m0-2A22.5,22.5,0,1,0,45,22.5,22.5,22.5,0,0,0,22.5,0Z",
  style: {
    fill: "#fff"
  }
})), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2-2",
  "data-name": "Layer 1-2"
}, /*#__PURE__*/React.createElement("line", {
  x1: 7.1,
  y1: 7.1,
  x2: 37.9,
  y2: 37.9,
  style: {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: "4.519999980926514px"
  }
}), /*#__PURE__*/React.createElement("line", {
  x1: 37.9,
  y1: 7.1,
  x2: 7.1,
  y2: 37.9,
  style: {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: "4.519999980926514px"
  }
})))))));
export default SvgClose;